import isEmpty from 'lodash/isEmpty'
import { SET_BG_CALIBRATION, SWITCH_BACKGROUND } from '../../constants/projectActions'
import { finishGaugingUp, startGaugingUp } from '../wallpapers'
import { disallowToResize } from './resizable'
import {startCropping} from "./crop";

export const switchBackground = ({ src, scale, calibration, ...rest }, index, fetch) => dispatch => {
  dispatch(finishGaugingUp(true, fetch))
  dispatch(disallowToResize())
  dispatch({ type: SWITCH_BACKGROUND, src, scale, index, rest, perMeter: calibration? calibration.perMeter : 300})

  isEmpty(calibration) ? dispatch(startCropping('background')) : dispatch(setBGCalibration(calibration.perMeter))
}

export const setBGCalibration = perMeter => ({ type: SET_BG_CALIBRATION, perMeter })



// WEBPACK FOOTER //
// ./src/actions/project/background.js